import { Controller } from "@hotwired/stimulus"

/**
 * Контроллер мобильного меню шапки workspace (p220m).
 * Простой toggle dropdown с блокировкой скролла body при открытии.
 */
export default class extends Controller {
  static targets = ["menu", "backdrop"]

  connect() {
    this._handleEscape = this._handleEscape.bind(this)
    document.addEventListener("keydown", this._handleEscape)
    document.addEventListener("turbo:before-render", this.close.bind(this))
  }

  disconnect() {
    document.removeEventListener("keydown", this._handleEscape)
    document.removeEventListener("turbo:before-render", this.close.bind(this))
    this._enableScroll()
  }

  toggle(event) {
    event?.preventDefault()
    event?.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.remove("hidden")
    }
    this._disableScroll()
  }

  close() {
    this.menuTarget.classList.add("hidden")
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.add("hidden")
    }
    this._enableScroll()
  }

  _handleEscape(event) {
    if (event.key === "Escape" && !this.menuTarget.classList.contains("hidden")) {
      this.close()
    }
  }

  _disableScroll() {
    this._scrollY = window.scrollY
    document.body.style.overflow = "hidden"
    document.body.style.position = "fixed"
    document.body.style.top = `-${this._scrollY}px`
    document.body.style.width = "100%"
  }

  _enableScroll() {
    document.body.style.overflow = ""
    document.body.style.position = ""
    document.body.style.top = ""
    document.body.style.width = ""
    if (this._scrollY !== undefined) {
      window.scrollTo(0, this._scrollY)
    }
  }
}
